import { Injectable } from '@angular/core';
import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

@Injectable({
	providedIn: 'root'
})
export class PasswordService {

	public readonly MIN_PASS_LENGTH = 8;

	constructor () { }

	confirmPasswordValidator(newPasswordControl: AbstractControl): ValidatorFn {
		return (control: AbstractControl): { [key: string]: boolean } | null => {
			if (control.value !== newPasswordControl.value) {
				return { passwordsDoNotMatch: true };
			}
			else {
				return null;
			}
		};
	}
}
